define.alias("shared/components/shared/post/secondary/hashtag-suggestions/error", "calendar/components/shared/post/secondary/hashtag-suggestions/error");